"use client";

import Image from "next/image";
import Link from "next/link";
import LoadingLink from "@/components/navigation/LoadingLink";

type LogoProps = {
  variant?: "full" | "icon";
  href?: string;
  className?: string;
  iconClassName?: string;
  showWordmark?: boolean;
};

export default function Logo({
  variant = "full",
  href = "/",
  className = "",
  iconClassName = "",
  showWordmark = true,
}: LogoProps) {
  const isIconOnly = variant === "icon";
  const showText = (variant === "full" || (isIconOnly && showWordmark));
  const img = (
    <>
      <Image
        src="/aptinomic-icon.svg"
        alt="Aptinomic"
        width={40}
        height={40}
        className={
          isIconOnly
            ? `h-10 w-10 shrink-0 ${iconClassName}`
            : `h-11 w-11 shrink-0 ${iconClassName}`
        }
        priority={variant === "full"}
      />
      {showText && (
        <span className="font-heading text-xl font-semibold text-slate-50 lowercase tracking-tight">
          aptinomic
        </span>
      )}
    </>
  );

  if (href) {
    const useNavLoader =
      href.startsWith("/") && !href.startsWith("//") && !href.includes("#");
    const cls = `inline-flex items-center gap-2.5 ${className}`;
    if (useNavLoader) {
      return (
        <LoadingLink href={href} className={cls}>
          {img}
        </LoadingLink>
      );
    }
    return (
      <Link href={href} className={cls}>
        {img}
      </Link>
    );
  }

  return <span className={`inline-flex items-center gap-2.5 ${className}`}>{img}</span>;
}
